import React, { useState } from "react";
import { FormFieldSet } from "../../../../../components";
import { PropsTable, TAGLIST_PROPS } from "./Props/Props";

const CATEGORIES = {
  core: { label: "Core", color: "#EFF6FF", textColor: "#1D4ED8" },
  validation: { label: "Validation", color: "#FFF7ED", textColor: "#C2410C" },
  display: { label: "Display", color: "#F0FDF4", textColor: "#15803D" },
  behavior: { label: "Behavior", color: "#FFFBEB", textColor: "#B45309" },
  suggestion: { label: "Suggestion", color: "#FDF2F8", textColor: "#9D174D" },
};

const TagList = () => {
  const [tags, setTags] = useState([]);
  return (
    <>
      <div className="grid grid-cols-7 my-5 mb-20">
        <FormFieldSet
          type="tags"
          value={tags}
          onChange={setTags}
          suggestionsList={["omkar", "rahim"]}
          maxCount={50}
        />
      </div>
      <PropsTable
        data={TAGLIST_PROPS}
        title="tags — Props Reference"
        typeLabel='type="tags"'
        categories={CATEGORIES}
      />
    </>
  );
};

export default TagList;
